import { Box, Grid, Typography } from '@mui/material'
import { StockProjectionExceptionsGraph } from './StockProjection.graph'
import { useTheme } from '@mui/material/styles'
import { useParams } from 'react-router-dom'
import { Loader } from 'Common/Loader/Loader'
import { StockProjectionParamTypes } from './StockProjection.types'
import { useWorkcentreKPIs } from 'Common/Hooks/UseWorkcentreKPIs.hooks'
import { formatDateWithHiphen } from 'Common/utils/utils'
import { useStockProjection } from 'Features/SourceSiteDashboard/SourceSiteDashboard.data'

export const StockProjectionView = () => {
  const theme = useTheme()
  const { workcentreId, planId } = useParams<StockProjectionParamTypes>()
  const { data: stockProjectionData, isLoading: stockProjectionDataLoading } =
    useStockProjection({
      planId: planId ?? '',
      workcentresList: workcentreId ? [workcentreId] : [],
    })

  const [kpis] = useWorkcentreKPIs(planId ?? '', workcentreId ?? '')

  if (stockProjectionDataLoading) {
    return <Loader />
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Grid container>
        <Grid size={4}>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            Total projected
          </Typography>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            stock-outs
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}
          >
            {kpis?.isStockOutOccasions ?? 0}
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            Total projected
          </Typography>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            low stock warnings
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}
          >
            {kpis?.isLowStockOccasions ?? 0}
          </Typography>
        </Grid>
        <Grid size={4}></Grid>
      </Grid>
      <Box>
        <StockProjectionExceptionsGraph
          xAxisData={stockProjectionData?.week.map(formatDateWithHiphen) ?? []}
          stockProjectionAlertData={
            stockProjectionData?.stockProjectionAlert ?? []
          }
          stockProjectionExceptionData={
            stockProjectionData?.stockProjectionException ?? []
          }
          stockProjectionOkData={stockProjectionData?.stockProjectionOk ?? []}
        />
      </Box>
    </Box>
  )
}
